import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { PushNotificationCampaign } from '../../../models/MasterAdmin/pushNotificationCampaign';
import { PUSH_HUB_BASE_PATH } from '../../../models/MasterAdmin/pushNotificationHub';
import type { PushCampaignEditorLocationState } from './PushCampaignEditorPage';

type Props = {
  open: boolean;
  initial: PushNotificationCampaign | null;
  onClose: () => void;
  onReadyToSend: (campaign: PushNotificationCampaign) => void;
  onSaved: () => void;
  onScheduled?: () => void;
};

/**
 * Compatibility shim: older launchers still open this modal.
 * It now routes to the full campaign editor page (WhatsApp-style).
 */
const CampaignFormModal: React.FC<Props> = ({ open, initial, onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    if (initial?.id) {
      navigate(`${PUSH_HUB_BASE_PATH}/campaigns/${initial.id}/edit`);
    } else {
      const prefills = initial
        ? {
            title: initial.title,
            message: initial.message,
            notificationType: initial.notificationType,
            intentType: initial.intentType,
            intentValue: initial.intentValue || '',
            targetAudience: initial.targetAudience,
            targetPlatform: initial.targetPlatform,
            targetUserId: initial.targetUserId || '',
            imageUrl: initial.imageUrl,
            templateId: initial.templateId || '',
          }
        : undefined;
      navigate(`${PUSH_HUB_BASE_PATH}/campaigns/new`, {
        state: { prefills } satisfies PushCampaignEditorLocationState,
      });
    }
    onClose();
  }, [open, initial, navigate, onClose]);

  return null;
};

export default CampaignFormModal;
